// @flow

import type { MessageDescriptor } from 'react-intl';

const prefix = 'tagFilters';

export default {
  filterButton: ({
    id: `${prefix}.labels.filterButton`,
    defaultMessage: 'Filtros',
    description: 'Filter button text',
  }: MessageDescriptor),
};
